var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('div',{attrs:{"id":"Content"}},[_c('router-view',{on:{"blankHeight":_vm.getBlankHeight}})],1),_c('div',{style:({ height: _vm.offsetHeight + 'px' })},[_vm._v(_vm._s(_vm.offsetHeight))]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }